import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Twitter, Linkedin, Github, Mail } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import translations from '../i18n/translations';
import './Footer.css';

export default function Footer() {
  const { lang } = useLang();
  const t = translations[lang].footer;
  const nav = translations[lang].nav;

  return (
    <footer className="footer">
      <div className="footer__glow" />
      <div className="container footer__inner">
        <div className="footer__brand">
          <Link to="/" className="footer__logo">
            <Shield size={20} />
            KYCPro<span>.AI</span>
          </Link>
          <p className="footer__tagline">{t.tagline}</p>
          <div className="footer__socials">
       <a href="#linkedin" aria-label="LinkedIn"><Linkedin size={18} /></a>
     {/*        <a href="#github" aria-label="GitHub"><Github size={18} /></a> */}
            <a href="mailto:info@CoreNexFlow.com" aria-label="Email"><Mail size={18} /></a>
          </div>
        </div>
        <div className="footer__cols">
          <div className="footer__col">
            <h4>{t.product}</h4>
            <Link to="/use-cases">{nav.useCases}</Link>
          {/*   <a href="#features">{t.features}</a> */}
             <Link to="/Features">{nav.Features}</Link>
            <Link to="/pricing">{t.pricing}</Link>
           {/*  <a href="#api">{t.api}</a> */}
          </div>
          <div className="footer__col">
            <h4>{t.company}</h4>
            <Link to="/about">{t.about}</Link>
           {/*  <a href="#careers">{t.careers}</a>
            <a href="#blog">{t.blog}</a>
            <a href="#press">{t.press}</a> */}
          </div>
          <div className="footer__col">
            <h4>{t.legal}</h4>
            <Link to="/privacy">{t.privacy}</Link>
            <Link to="/terms">{t.terms}</Link>
           {/*  <a href="#gdpr">{t.gdpr}</a>
            <a href="#compliance">{t.compliance}</a> */}
          </div>
        </div>
      </div>
      <div className="footer__bottom container">
        <p>© {new Date().getFullYear()} KYCPro.AI. {t.rights}</p>
        <p>{t.built}</p>
      </div>
    </footer>
  );
}
